import { api } from '../api';

export type TmkExportEstado = 'corriendo' | 'terminado' | 'error';

export interface TmkExportJob {
  /** El backend serializa _id→id (defaultSchemaOptions). Dejamos ambos por las dudas. */
  id?: string;
  _id?: string;
  scope: string;
  estado: TmkExportEstado;
  startedAt: string;
  finishedAt?: string;
  total: number;
  procesados: number;
  fileId?: string;
  filename?: string;
  error?: string;
  disparadoPor?: string;
}

export function tmkExportJobId(job: TmkExportJob): string {
  return job.id ?? job._id ?? '';
}

/** Dispara la generación del CSV en background. Devuelve el job (202). */
export async function dispararExportTmk(): Promise<TmkExportJob> {
  const { data } = await api.post<TmkExportJob>('/tmk/export/disparar', {});
  return data;
}

/** Último job de export; 404 (nunca corrió) → null. */
export async function getTmkExportLatest(): Promise<TmkExportJob | null> {
  try {
    const { data } = await api.get<TmkExportJob>('/tmk/export/jobs/latest');
    return data;
  } catch (err) {
    const e = err as { response?: { status?: number } };
    if (e.response?.status === 404) return null;
    throw err;
  }
}

/** Descarga el CSV ya generado (blob → <a download>). */
export async function descargarExportTmk(id: string, filename?: string): Promise<void> {
  const { data, headers } = await api.get(`/tmk/export/${id}/descargar`, { responseType: 'blob' });
  const cd = (headers?.['content-disposition'] as string | undefined) ?? '';
  const name = filename ?? parseFilename(cd) ?? 'contactos-tmk.csv';
  const blob = new Blob([data as BlobPart], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function parseFilename(contentDisposition: string): string | undefined {
  const star = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
  if (star) return decodeURIComponent(star[1]);
  const plain = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return plain ? plain[1] : undefined;
}
